import classNames from "classnames"

import { Icon } from "web/components"

export default function ViewModeSelector({ viewModes, currentViewMode }) {
  return (
    <div className="view-selector hidden space-x-1 rounded-lg bg-white p-1 shadow-inner-2xl sm:flex">
      {viewModes.map(({ url, title, key, icon, className = "" }) => (
        <a href={url} key={key} data-turbo-action="advance">
          <div
            className={classNames(
              "flex h-8 w-8 cursor-pointer items-center justify-center gap-x-0.5 rounded hover:bg-primary-10",
              { "bg-primary-10": key === currentViewMode }
            )}
            data-testid={`button-view-selector-${key}`}
          >
            <Icon
              name={icon}
              className={classNames(className, "")}
              outline
              title={title}
            />
          </div>
        </a>
      ))}
    </div>
  )
}
